/**
 * Set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_PENDING = (state) => {
    state.pending = true
}

/**
 * Handle the successful GET request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const GET_WAR_ROOM_SUCCESS = (state, payload) => {
    state.data = payload
    state.pending = false
}

/**
 * Handle the failed GET request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const GET_WAR_ROOM_FAILURE = (state, error) => {
    state.data = {}
    state.pending = false
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    state.data = {
        files: []
    }
    state.pending = false
}

/**
 * Handle successful DELETE request to a file
 *
 * @param  {[type]} state
 * @return {[type]}
 */
const FILE_DELETED_SUCCESS = (state, id) => {
    state.data.files.splice(state.data.files.findIndex(item => item.id === id), 1)
}

/**
 * Add a file to the files array
 *
 * @param  {Object} state
 * @param  {Object} file
 * @return {Void}
 */
const ADD_FILE = (state, file) => {
    state.data.files.push(file)
}

/**
 * Add file to selected state object
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Void}
 */
const SELECT_FILE = (state, id) => {
    state.selected.push(id)
}

/**
 * Remove file from selected state object
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Void}
 */
const DESELECT_FILE = (state, index) => {
    state.selected.splice(index, 1)
}

/**
 * Select all files
 *
 * @param  {Object} state
 * @return {Void}
 */
const SELECT_ALL_FILES = (state) => {
    state.selected = state.data.files.map(file => file.id)
}

/**
 * Deselect all files
 *
 * @param  {Object} state
 * @return {Void}
 */
const DESELECT_ALL_FILES = (state) => {
    state.selected = []
}

/**
 * Remove multiple files from the war room
 *
 * @param  {Object} state
 * @return {Void}
 */
const REMOVE_MULTIPLE_FILES = (state) => {
    state.data.files = state.data.files.filter(file => !state.selected.includes(file.id))
}

/**
 * Replace a file in the war room
 *
 * @param  {Object} state
 * @return {[type]}
 */
const REPLACE_FILE = (state, payload) => {
    let idx = state.data.files.findIndex(file => file.id === payload.id)

    state.data.files.splice(idx, 1, payload)
}

export default {
    ADD_FILE,
    RESET_STATE,
    SET_PENDING,
    SELECT_FILE,
    REPLACE_FILE,
    DESELECT_FILE,
    SELECT_ALL_FILES,
    DESELECT_ALL_FILES,
    FILE_DELETED_SUCCESS,
    GET_WAR_ROOM_SUCCESS,
    GET_WAR_ROOM_FAILURE,
    REMOVE_MULTIPLE_FILES
}



// WEBPACK FOOTER //
// ./src/state/modules/war-room/mutations.js